"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleableComponent = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.split.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _utils = require("../../common/utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ToggleableComponent = function ToggleableComponent(props) {
  var ToRender = props.ToRender,
    toRenderProps = props.toRenderProps,
    toggle = props.toggle,
    toggles = props.toggles,
    children = props.children,
    entityType = props.entityType,
    entityId = props.entityId,
    ifNot = props.ifNot,
    loading = props.loading;
  var toggleInToggles = function toggleInToggles(toMatch) {
    var toggleList = toggles;
    if (_lodash.default.isString(toggles)) {
      toggleList = _lodash.default.map(_lodash.default.split(toggleList, ','), function (t) {
        return _lodash.default.trim(t);
      });
    }
    return _lodash.default.find(toggleList, function (curr) {
      return (0, _utils.matchesToggle)(toMatch, curr, entityType, entityId);
    }) !== undefined;
  };
  var showComponent = toggleInToggles(toggle) || toggle.indexOf('!') === 0 && !toggleInToggles(toggle.substring(1));
  if ((ifNot && !showComponent || !ifNot && showComponent) && !loading) {
    if (ToRender !== undefined) {
      return /*#__PURE__*/_react.default.createElement(ToRender, toRenderProps);
    } else {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
    }
  } else {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
};
exports.ToggleableComponent = ToggleableComponent;